import React, { Component } from 'react';
import DonationInfo from './DonationInfo';
import DonationTab from './DonationTab';

export default class extends Component {
    render() {
        var donation = this.props.donation;

        const { BoxActions } = this.props;

        // 정기 & 일시
        var donationProgressType = true;
        var percent = 0; 
        var payPrice = 0;
        var memberCount = 0;

        switch (this.props.selectDonationType) {
            case "pledge":
                donationProgressType = donation.pledge.donationProgressType;
                percent = donation.pledge.percent;
                payPrice = donation.pledge.monthlyPayPrice;
                memberCount = donation.pledge.memberCount;
                break;
            case "oneoff":
                donationProgressType = donation.oneOff.donationProgressType;
                percent = donation.oneOff.percent;
                payPrice = donation.oneOff.payPrice;
                memberCount = donation.oneOff.memberCount;
                break;
        }
        return (
            <div className="donation-info">
                <DonationTab
                    selectDonationType={this.props.selectDonationType}
                    donation={this.props.donation}
                    onSelectDonationType={function (selectDonationType) {
                        BoxActions.updateDonationType(selectDonationType);
                    }.bind(this)}
                />

                <DonationInfo
                    selectDonationType={this.props.selectDonationType}
                    donationProgressType={donationProgressType}
                    percent={percent}
                    payPrice={payPrice}
                    memberCount={memberCount}
                    payButtonText={donation.payButtonText}
                    boxStatus={this.props.boxStatus}
                    payUrl={this.props.payUrl}
                />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/content/ContentDonationRoot.js